import React, { useCallback, useEffect, useState } from "react";
import Breadcrumb from "../../Component/Breadcrumb";
import { Helmet } from "react-helmet";
import { useAuth } from "../../Store/AuthContext";
import axios from "axios";
import FounderDeskBox from "./FounderDeskBox";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "admin/API/";

export default function FoundersDesk() {
  const { RendomTokenfetch, Pagemetatags } = useAuth();
  const [teamData, setteamData] = useState([]);
  const [loading, setLoading] = useState(false);

  const FetchTeamData = useCallback(async () => {
    setLoading(true);
    try {
      await axios
        .get(`${WebsiteAPIurl}teamAPI.php`, {
          headers: {
            Authorization: RendomTokenfetch,
          },
        })
        .then((response) => {
          // console.log(response.data);
          if (response.data.status === "1") {
            setteamData(response.data.teamdata);
          }
          if (response.data.status === "0") {
            setteamData([]);
          }
        });
    } catch (error) {
      console.error("Error fetching leads:", error);
    } finally {
      setLoading(false);
    }
  }, [RendomTokenfetch]);

  useEffect(() => {
    FetchTeamData();
  }, [FetchTeamData]);

  if (loading) {
    // return <APIDataFetchLoader />;
  }
  return (
    <>
      <Helmet>
        <title>{Pagemetatags.team_title}</title>
        <meta name="description" content={Pagemetatags.team_description} />
        <meta name="keywords" content={Pagemetatags.team_keyword} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      <Breadcrumb pagename="Founders Desk" mainpage="" />
      <section
        className="propertie-section-3 fix section-padding bg-cover pb-0"
        style={{ backgroundImage: `url('assets/img/propertie-bg.jpg')` }}
      >
        <div className="container">
          <div className="propertie-wrapper-3">
            {loading ? (
              <p className="text-center">Loading Teams...</p>
            ) : teamData.length > 0 ? (
              teamData.map((teamval, index) => (
                <FounderDeskBox key={index} Datateam={teamval} />
              ))
            ) : (
              <p className="text-center">No Team Available Right Now.</p>
            )}
          </div>
        </div>
      </section>
      {/* <section
        className="propertie-section-3 fix section-padding bg-cover pt-0"
        style={{ backgroundImage: `url('assets/img/propertie-bg.jpg')` }}
      >
        <div className="container">
          <div className="propertie-wrapper-3">
            <div className="row g-4">
              <div className="col-xl-3 col-lg-6 teamDev">
                <div className="propertie-image">
                  {aboutData.manager_image !== "" ? (
                    <img src={aboutData.manager_image} alt="" />
                  ) : (
                    <img src="assets/img/home-3/team/team5.jpg" alt="img" />
                  )}
                  <div className="team-content text-center mt-3">
                    <h4> {aboutData?.managername || ""}</h4>
                    <p className="text-center">
                      {aboutData?.managertitle || ""}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-xl-9 col-lg-6">
                <div className="content">
                  <p className="wow fadeInUp" data-wow-delay=".5s">
                    {aboutData?.manager_description || ""}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
    </>
  );
}
